import React, { useEffect } from 'react';
import { FeedType, Post } from '@app/types/core';
import { ANNOUNCEMENTS } from '@core/constants/postFeedType';
import { Box, Loader, useMediaQuery, useTheme } from '@ublend-npm/aulaui-core';
import ScheduledPostsSummary from './ScheduledPostsSummary.container';
import ScheduledPostListWrapper from '../../Shared/SchedulePost/ScheduledPostListWrapper';
import pushRoute from '@app/utils/routing';
import { getScheduledPostListPath } from '@app/actions/navigation';
import NoResultsCard from '@app/components/presentational/common/NoResults/NoResultsCard';
import {
  NO_SCHEDULED_POSTS_DESCRIPTION,
  NO_SCHEDULED_POSTS_TITLE,
} from '../../Shared/text';

const getPageTitle = (feedType: FeedType, count) =>
  `Scheduled ${feedType === ANNOUNCEMENTS ? 'announcement' : 'post'}${
    count !== 0 ? 's' : ''
  }`;

interface ScheduledPostListResponsiveProps {
  count?: number;
  spaceId: string | null;
  currentSpaceName?: string;
  scheduledPosts?: Post[];
  isFetching?: boolean;
  feedType: FeedType;
  isChangingClassRoom?: boolean;
  goToCommonRoom?: (spaceId: string) => void;
}

const loaderStyle: any = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
};

const ScheduledPostListResponsive = ({
  currentSpaceName = '',
  scheduledPosts,
  spaceId = null,
  count = 0,
  feedType,
  isChangingClassRoom,
  goToCommonRoom,
}: ScheduledPostListResponsiveProps) => {
  // Check if the screen is mobile
  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));

  useEffect(() => {
    const space = currentSpaceName ? `${currentSpaceName} - ` : '';
    document.title = `${getPageTitle(feedType, count)} - ${space}Aula`;
  }, [currentSpaceName, feedType, count]);

  // Navigate to '/scheduled/list' if its a mobile screen
  useEffect(() => {
    if (isMobile && spaceId) {
      pushRoute(getScheduledPostListPath(spaceId));
    }
  }, [isMobile, spaceId]);

  const isLoading = isChangingClassRoom || !spaceId;

  // TODO: Add a skeleton loader
  if (isLoading) {
    return (
      <Box sx={loaderStyle}>
        <Loader />
      </Box>
    );
  }

  return (
    <ScheduledPostListWrapper
      count={count}
      onClose={() => {
        if (spaceId && goToCommonRoom) {
          goToCommonRoom(spaceId);
        }
      }}
    >
      {(scheduledPosts ?? [])?.length === 0 ? (
        <NoResultsCard
          title={NO_SCHEDULED_POSTS_TITLE}
          description={NO_SCHEDULED_POSTS_DESCRIPTION}
          sx={{ width: '100%' }}
        />
      ) : (
        (scheduledPosts ?? [])?.map((post: Post, index: number) => (
          <Box key={index}>
            <ScheduledPostsSummary scheduledPost={post} />
          </Box>
        ))
      )}
    </ScheduledPostListWrapper>
  );
};

export default ScheduledPostListResponsive;
